/**
 * @description: 艺人报备汇总报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="wr-ybh-report">
        <div class="ybh-list">
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-2">
                    <div ref="ybhTime">
                        <input type="text" class="form-control laydate-icon" v-model="ybhStartTime">
                    </div>
                </div>
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="ybhShop" data-placeholder="请选择消费门店"></select>
                </div>
                <label class="list-label-2">主管:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="ybh_charger" data-placeholder="请选择主管"></select>
                </div>
                <label class="list-label-2">组别:</label>
                <div class="col-md-2">
                    <input class="form-control input-readonly" placeholder="请选择组别" v-model="ybh_group_txt" ref="ybh_group_txt" readonly @click="ybhEnterGroup">
                    <span class="selection-clear">×</span>
                    <span class="span-arrow" role="presentation"><b></b></span>
                </div>
                <div>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="innitYbhTable" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getYbhExportSet">导出</button>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="ybhList"></table>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="ybhExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='ybhExport_allcheck' @click='ybhExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ybhExport_checkModel' value="shop_name">
                            <label>门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ybhExport_checkModel' value="group_name">
                            <label>组别</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ybhExport_checkModel' value="director_name">
                            <label>主管</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ybhExport_checkModel' value="sign_type3">
                            <label>陪宴(人)</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ybhExport_checkModel' value="sign_type1">
                            <label>签到(人)</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ybhExport_checkModel' value="sign_type4">
                            <label>私事(人)</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ybhExport_checkModel' value="sign_type2">
                            <label>例假(人)</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ybhExport_checkModel' value="sign_type5">
                            <label>其他(人)</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ybhExport_checkModel' value="no_sign_members">
                            <label>未报备(人)</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='ybhExport_checkModel' value="group_members">
                            <label>汇总(人)</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='ybhExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='ybhExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- 组别列表 -->
        <div class="ybh-group">
            <h3>请选择组别</h3>
            <div class="group-search pull-right">
                <input type="text" placeholder="请输入组别名称" v-model="ybh_group_name">
                <img src="../../../assets/images/group_search.png" @click="getYbhGroupData">
            </div>
            <!-- 列表 -->
            <div class="group-list">
                <ul class="clearfix">
                    <li>
                        <input type='checkbox' v-model='ybh_group_allcheck' @click='groupYbhCheckedAll'>
                        <label>全部组别</label>
                    </li>
                    <li v-for="item in ybh_group_checkboxData" :key="item.group_id">
                        <input type="checkbox" v-model='ybh_group_checkboxModel' :value='item.group_id'>
                        <label>{{item.group_name}}</label>
                    </li>
                </ul>
            </div>
            <div class="row">
                <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="ybhGroupBack()">返回</button>
                <button type="button" class="btn btn-flat btn-middle btn-orange" @click="ybhGroupSub()">确定</button>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                ybhStartTime: "",
                ybh_group_txt: "",
                ybh_group_allcheck: false,
                ybh_c_group_allcheck: false,
                ybh_group_checkboxModel: [],
                c_ybh_group_checkboxModel: [],
                ybh_group_checkboxData: [],
                ybh_group_name: '',
                ybhExport_allcheck: false,
                c_ybhExport_allcheck: false,
                ybhExport_checkModel: [],
                ybhExport_checkData: ['shop_name', 'group_name', 'director_name', 'sign_type3', 'sign_type1', 'sign_type4', 'sign_type2', 'sign_type5', 'no_sign_members', 'group_members'],
                ybhExport_type: 1,
            }
        },
        watch: {
            ybh_group_checkboxModel: {
                handler: function(val, oldVal) {
                    if(this.ybh_group_checkboxModel.length >= this.ybh_group_checkboxData.length) {
                        this.ybh_group_allcheck = true;
                        this.ybh_c_group_allcheck = true;
                    } else {
                        this.ybh_group_allcheck = false;
                        this.ybh_c_group_allcheck = false;
                    }
                },
                deep: true
            },
            ybhExport_checkModel: {
                handler: function(val, oldVal) {
                    if(this.ybhExport_checkModel.length >= this.ybhExport_checkData.length) {
                        this.ybhExport_allcheck = true;
                        this.c_ybhExport_allcheck = true;
                    } else {
                        this.ybhExport_allcheck = false;
                        this.c_ybhExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            // 日期
            this.ybhStartTime = moment().format('YYYY-MM-DD');
            this.innitDate(); // 日期
            this.shopDatas = [];
            this.innitInput();  // 门店
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.ybhStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD');
                        }else {
                            this.ybhStartTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.ybhTime).daterangepicker({
                    singleDatePicker: true,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                }, function(start, end, label) {
                    _this.ybhStartTime = start.format('YYYY-MM-DD');
                });
            },
            // 初始化门店输入框
            innitInput: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                _this.shopDatas.push({
                                    id: v.id,
                                    text: v.name
                                });
                            });
                            $(_this.$refs.ybhShop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                _this.ybh_group_checkboxModel = [];
                                _this.ybh_group_txt = '';
                                if(e.params.data.text == "全部") {
                                    // 主管
                                    $(_this.$refs.ybh_charger).val('').trigger('change');
                                    $(_this.$refs.ybh_charger).prop("disabled", true);
                                    return;
                                }
                                // 主管
                                $(_this.$refs.ybh_charger).prop("disabled", false);
                                _this.getChargeData(e.params.data.id);
                                _this.setShopDefaultTime(e.params.data.id);
                            });
                            $(_this.$refs.ybhShop).val(data.response.result[1].id).trigger('change');
                            // 主管
                            $(_this.$refs.ybh_charger).prop("disabled", false);
                            _this.getChargeData(data.response.result[1].id);
                            _this.setShopDefaultTime(data.response.result[1].id);
                            _this.innitYbhTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取主管
            getChargeData: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getDirectorSearchList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            let arr = [{ id: ' ', text: '全部', type: '' }];
                            $.each(data.response.result, function(k, v) {
                                arr.push({ id: v.id, text: v.name, type: v.type });
                            });
                            $(_this.$refs.ybh_charger).html('');
                            $(_this.$refs.ybh_charger).select2({
                                data: arr,
                                minimumResultsForSearch: -1,
                                language: "zh-CN",
                                width: '100%'
                            })
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {
                        layer.msg('网络错误');
                    }
                });
            },



            // 进入选择组别
            ybhEnterGroup: function() {
                this.c_ybh_group_checkboxModel = this.ybh_group_checkboxModel;
                this.ybh_group_checkboxModel = [];
                this.getYbhGroupData();
                this.ybh_group_checkboxModel = this.c_ybh_group_checkboxModel;
                $('.ybh-list').hide();
                $('.ybh-group').show();
            },
            // 获取组别列表
            getYbhGroupData: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": '0',
                            "page_size": '0',
                            "shop_id": $(_this.$refs.ybhShop).val(),
                            "key_word": 'personnel',
                            "group_name": _this.ybh_group_name
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getGroupSearchList",
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.ybh_group_checkboxData = data.response.result;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 全选
            groupYbhCheckedAll: function() {
                let _this = this;
                _this.ybh_group_allcheck = _this.ybh_c_group_allcheck;
                if(!_this.ybh_group_allcheck) { // 实现全选
                    _this.ybh_group_checkboxModel = [];
                    _this.ybh_group_checkboxData.forEach(function(item) {
                        _this.ybh_group_checkboxModel.push(item.group_id);
                    });
                } else { // 实现反选
                    _this.ybh_group_checkboxModel = [];
                }
            },
            // 返回
            ybhGroupBack: function() {
                $('.ybh-group').hide();
                $('.ybh-list').show();
                this.ybh_group_checkboxModel = this.c_ybh_group_checkboxModel;
            },
            ybhGroupSub: function() {
                let _this = this;
                let arr = [];
                _this.ybh_group_checkboxData.forEach(function(item) {
                    _this.ybh_group_checkboxModel.forEach(function(sub) {
                        if(item.group_id == sub) {
                            arr.push(item.group_name);
                        }
                    });
                });
                _this.ybh_group_txt = arr.join(',');
                $('.ybh-group').hide();
                $('.ybh-list').show();
            },
            // 表格
            innitYbhTable: function() {
                let _this = this;
                $(_this.$refs.ybhList).bootstrapTable('destroy');
                $(_this.$refs.ybhList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 15,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getYbhList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "index",
                        title: "行号",
                        width: "5%",
                        formatter: function(value, row, index) {
                            return index + 1;
                        }
                    }, {
                        field: "shop_name",
                        title: "门店",
                        width: "10%"
                    }, {
                        field: "group_name",
                        title: "组别",
                        width: "8%"
                    }, {
                        field: "director_name",
                        title: "主管",
                        width: "8%"
                    }, {
                        field: "sign_type3",
                        title: "陪宴(人)",
                        width: "8%"
                    }, {
                        field: "sign_type1",
                        title: "签到(人)",
                        width: "8%"
                    }, {
                        field: "sign_type4",
                        title: "私事(人)",
                        width: "8%"
                    }, {
                        field: "sign_type2",
                        title: "例假(人)",
                        width: "8%"
                    }, {
                        field: "sign_type5",
                        title: "其他(人)",
                        width: "8%"
                    }, {
                        field: "no_sign_members",
                        title: "未报备(人)",
                        width: "8%"
                    }, {
                        field: "group_members",
                        title: "汇总(人)",
                        width: "8%"
                    }],
                });
            },
            // 数据
            getYbhList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "time": _this.ybhStartTime,
                            "shop_id": $(_this.$refs.ybhShop).val(),
                            "director_uid": $.trim($(_this.$refs.ybh_charger).val()),
                            "group_id": _this.ybh_group_checkboxModel
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport2/getPersonnelSignInSummary",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.data.total,
                                rows: data.response.data.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取导出设置
            getYbhExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport2/personnelSignInSummaryExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.ybhExport_checkModel = data.response.result.export_fields;
                                _this.ybhExport_type = data.response.result.export_type;
                            } else {
                                _this.ybhExport_checkModel = _this.ybhExport_checkData;
                                _this.ybhExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.ybhExport_alert)
                }, function() {
                    _this.exportYbhList();
                });
            },
            // 导出字段全选
            ybhExportCheckedAll: function() {
                let _this = this;
                _this.ybhExport_allcheck = _this.c_ybhExport_allcheck;
                if(!_this.ybhExport_allcheck) { // 实现全选
                    _this.ybhExport_checkModel = [];
                    _this.ybhExport_checkData.forEach(function(item) {
                        _this.ybhExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.ybhExport_checkModel = [];
                }
            },
            // 导出
            exportYbhList: function() {
                let _this = this;
                let export_fields = JSON.stringify(_this.ybhExport_checkModel);
                window.location.href = Vue.ctUrl + "FinanceReport2/personnelSignInSummaryExport?" +
                    "time=" + _this.ybhStartTime +
                    "&shop_id=" + $(_this.$refs.ybhShop).val() +
                    "&director_uid=" + $.trim($(_this.$refs.ybh_charger).val()) +
                    "&group_id=" + _this.ybh_group_checkboxModel +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.ybhExport_type;
                // debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    /* 组别 */
    .ybh-group {
        display: none;
        .group-search {
            position: relative;
            margin: 0 0 30px;
            input {
                width: 300px;
                height: 36px;
                padding: 0 45px 0 16px;
                color: #888;
                font-size: 16px;
                background: #f5f5f5;
                border-radius: 6px;
            }
            img {
                position: absolute;
                right: 10px;
                top: 6px;
                width: 24px;
                cursor: pointer;
            }
            button {
                margin: 0 30px 0 0;
            }
        }
        .group-list {
            clear: both;
            li:first-child {
                width: 100%;
                input {
                    margin: 2px 10px 0 0;
                }
            }
            li {
                float: left;
                width: 20%;
                margin: 0 0 30px;
                font-size: 14px;
                input {
                    float: left;
                    margin: 2px 10px 0 30px;
                }
                label {
                    margin: 0;
                    font-weight: normal;
                }
            }
        }
        .row {
            button {
                margin: 0 30px 0 0;
            }
        }
    }
</style>